module.exports = __webpack_public_path__ + "img/2.39a77077.png";